import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
	output,
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { DropdownComponent } from '@valk-nx/components/ui-dropdown/src/lib/dropdown';
import { DropdownOption } from '@valk-nx/components/ui-dropdown/src/lib/dropdown.interface';
import { ViewPortService } from '@valk-nx/services/viewport/src/lib/viewport.service';

import { FilterButtonComponent } from '../filter-button/filter-button';

export const DEFAULT_SORT_OPTIONS: DropdownOption[] = [
	{ value: 'name-asc', label: 'global.sort.name-asc' },
	{ value: 'name-desc', label: 'global.sort.name-desc' },
	{ value: 'price-asc', label: 'global.sort.price-asc' },
	{ value: 'price-desc', label: 'global.sort.price-desc' },
];

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: `vp-filter-heading`,
	templateUrl: './filter-heading.html',
	imports: [DropdownComponent, FilterButtonComponent, TranslatePipe],
})
export class FilterHeadingComponent {
	private readonly viewport = inject(ViewPortService);

	title = input.required<string>();
	sortOptions = input<DropdownOption[]>(DEFAULT_SORT_OPTIONS);
	indicator = input<number>(0);
	numberOfResults = input<number | undefined>(undefined);

	sortChanged = output<string>();

	dropdownAlignment = computed(() => {
		return this.viewport.isXxlWidth() ? 'left' : 'right';
	});

	onSortChange(value: string) {
		this.sortChanged.emit(value);
	}
}
